/**
 * Почему пользователь снова на входе — значение `?notice=` в адресе `/login`, рядом с `from`.
 * Ставят ворота кабинета (сеанс кончился посреди работы, P-AUTH-02#R-06); читает форма входа
 * и показывает плашку до отправки.
 */
export const LOGIN_NOTICE = {
  sessionEnded: 'session-ended',
} as const
